(function () {
    function categoryHandler() {
        const categories = document.querySelectorAll('[data-category]');
        const mapInstitute = document.getElementById('map-institute');
        mapInstitute.style.display = 'none';

        categories.forEach(item => {
            item.addEventListener('click', () => triggerCategory(item));
        });

        function handleClick(event) {
            if (event.target.classList.contains('contact-map__category')) {
                const regions = event.target.dataset.regions || null;
                loadMap(regions);
            }
        }

        document.addEventListener('click', handleClick);
    }

    function triggerCategory(item, scroll = true) {
        const items = document.querySelectorAll('[data-department-id]');
        items.forEach(item => item.classList.remove('contact-map__category--active'));

        hideMapInstitute();

        item.classList.add('contact-map__category--active');

        const topBarHeight = $('.topBar').length ? $('.topBar').height() : 0;
        if (item.dataset.regions) {
            if (scroll) {
                // $([document.documentElement, document.body]).animate({
                //     scrollTop: $('.contact-map__map').offset().top - topBarHeight,
                // }, 300);
                window.scrollToElement('.contact-map__map', 0, 300);
            }
        } else {
            const regionId = item.dataset.category;
            const map = document.getElementById('map-canvas');
            const search = document.querySelector('.contact-map__search');

            search.style.display = 'none';
            map.style.display = 'none';

            if ($(`[data-category-id="${regionId}"]`).length) {
                $('[data-category-id]').hide();
                $('[data-map-contacts]').show();

                $('[data-map-contact-title]').hide();
                $(`[data-category-id="${regionId}"]`).css("display", "flex").hide().fadeIn();

                if (scroll) {
                    // setTimeout(() => {
                    //     $([document.documentElement, document.body]).animate({
                    //         scrollTop: $('.contact-map__contacts').offset().top - topBarHeight,
                    //     }, 300);
                    // }, 200);
                    window.scrollToElement('.contact-map__contacts', 0, 300);
                }
            }
        }
    }

    function loadMap(regions, item = null) {
        const map = document.getElementById('map-canvas');
        const search = document.querySelector('.contact-map__search');

        if (map) {
            search.querySelector('input').value = '';
        }

        if (map && regions && regions.length) {
            map.innerHTML = '';
            map.style.display = 'block';
            map.dataset.regions = regions;
            search.style.display = 'flex';
            initializeGoogleMap(JSON.parse(regions));
        } else {
            map.innerHTML = '';
            map.style.display = 'none';
            item && triggerCategory(item);
        }
    }

    function tabs() {
        const tabs = document.querySelectorAll('[data-department]');
        const items = document.querySelectorAll('[data-department-id]');

        hideMapInstitute();
        openFirstTab();

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                let tabActive;
                const activeID = tab.dataset.department;
                const currentItems = document.querySelectorAll(`[data-department-id="${activeID}"]`);

                hideTabItems();
                tab.classList.add('contact-map__department--active');

                currentItems.forEach(item => {
                    const itemID = item.dataset.departmentId;

                    if (itemID == activeID) {
                        item.style.display = 'flex';
                    }
                    const itemActive = document.querySelectorAll(`[data-department-id="${activeID}"]`)[0];
                    tabActive = itemActive;
                });

                currentItems.forEach(item => {
                    if (item.dataset.selected) {
                        tabActive = item;
                    }
                });

                items.forEach(item => item.classList.remove('contact-map__category--active'));
                tabActive.classList.add('contact-map__category--active');

                const regions = tabActive.dataset.regions;
                loadMap(regions, tabActive);
            });
        });
    }

    function openFirstTab() {
        const tabs = document.querySelectorAll('[data-department]');
        const items = document.querySelectorAll('[data-department-id]');

        let paramDepartmentId = 0;
        let paramCategoryId;
        const params = new URL(window.location.href).searchParams;
        if (params.get('cat')) {
            paramDepartmentId = params.get('cat');
        }
        if (params.get('cat')) {
            paramCategoryId = params.get('subcat');
        }
        if (!tabs[paramDepartmentId]) {
            paramDepartmentId = 0;
        }

        const activeID = tabs[paramDepartmentId].dataset.department;
        let tabActive;

        tabs[paramDepartmentId].classList.add('contact-map__department--active');

        items.forEach(item => {
            const itemID = item.dataset.departmentId;

            if (itemID == activeID) {
                item.style.display = 'flex';
            }

            const itemActive = document.querySelectorAll(`[data-department-id="${activeID}"]`)[0];
            tabActive = itemActive;
        });


        if (params.get('cat')) {
            tabActive = document.querySelectorAll(`[data-department-id="${activeID}"]`)[paramCategoryId] || tabActive;
        } else {
            items.forEach(item => {
                if (item.dataset.selected) {
                    tabActive = item;
                }
            });
        }

        tabActive.classList.add('contact-map__category--active');
        triggerCategory(tabActive, scroll = false);

        const regions = tabActive.dataset.regions;
        loadMap(regions);


        if (params.get('cat')) {
            const topBarHeight = $('.topBar').length ? $('.topBar').height() : 0;
            $('html, body').animate({
                scrollTop: $('#contact-map-filters').offset().top - topBarHeight
            }, 700);
        }
    }

    function hideTabItems() {
        const tabs = document.querySelectorAll('[data-department]');
        const items = document.querySelectorAll('[data-department-id]');

        tabs.forEach(tab => {
            tab.classList.remove('contact-map__department--active');
        });

        items.forEach(item => {
            item.style.display = 'none';
        });
    }

    function hideMapInstitute() {
        const mapInstitute = document.getElementById('map-institute');
        mapInstitute.style.display = 'none';
    }

    function phoneModal() {
        const btn = document.querySelector('[data-phone-modal-btn]');

        if (btn) {
            const modal = document.querySelector('[data-phone-modal]');
            const close = document.querySelector('[data-phone-modal-close]');
            const hideModal = () => {
                modal.classList.remove('contact__data-modal--active');
            };

            btn.addEventListener('click', () => {
                modal.classList.add('contact__data-modal--active');
            });

            // window.addEventListener('click', e => {
            //     if (modal.contains(e.target)) {
            //         hideModal();
            //     }
            // });

            close.addEventListener('click', () => hideModal());
        }
    }

    function scrollToSection() {
        $(document).on('click', 'a[href^="#"]', function (e) {
            e.preventDefault();
            const topBarHeight = $('.topBar').length ? $('.topBar').height() : 0;

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - topBarHeight
            }, 700);
        });
    }

    function copyText() {
        const texts = document.querySelectorAll("[data-text-copy]");

        if (texts.length) {
            texts.forEach(text => {
                text.onclick = function () {
                    document.execCommand("copy");
                }
                text.addEventListener("copy", function (event) {
                    event.preventDefault();
                    if (event.clipboardData) {
                        event.clipboardData.setData("text/plain", text.dataset.textCopy);
                    }
                });
            });
        }
    }


    window.addEventListener('load', () => {
        const map = document.getElementById('map-canvas');

        if (map) {
            categoryHandler();
            tabs();
            phoneModal();
            scrollToSection();
        }
        copyText();
    });




    let map;
    let markers = [];

    function initializeGoogleMap(regions = null) {
        const $ = jQuery;
        const mapCanvas = document.getElementById('map-canvas');

        if (mapCanvas) {

            hideMapInstitute();

            const mapOptions = {
                zoom: 15,
                scrollwheel: false,
                center: new google.maps.LatLng(50.0467656, 20.0048731),
                styles: [
                    { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] },
                    { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] },
                    { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                    { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] },
                    { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
                    { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
                    { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                    { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#e2231a" }, { "visibility": "on" }] },
                ],
            };

            hideContacts();

            regions = regions ? regions : mapCanvas.dataset.regions;

            map = new google.maps.Map(mapCanvas, mapOptions);
            map.data.setStyle({ fillColor: '#E70506', strokeColor: '#E70506', strokeWeight: 1 });

            const ajaxQueue = [];
            $.each(regions, function (index, element) {
                ajaxQueue.push($.ajax(element.kml).done(function (xml) {
                    const geoJson = toGeoJSON.kml(xml);
                    geoJson.features[0].properties.id = element.id;
                    geoJson.features[0].properties.title = element.title;
                    map.data.addGeoJson(geoJson);
                }));
            });

            $.when.apply($, ajaxQueue).done(function () {
                zoom(map);
            });

            map.data.addListener('click', function (event) {
                const regionId = event.feature.getProperty('id');
                const regionTitle = event.feature.getProperty('title');
                const contacts = $('[data-region-id]');
                console.log(event.feature);

                map.data.revertStyle();
                map.data.overrideStyle(event.feature, { fillOpacity: '0.5' });

                event.feature.setProperty('fill-opacity', '1');
                event.feature.setProperty('stroke', '#444');

                hideContacts();

                const topBarHeight = $('.topBar').length ? $('.topBar').height() : 0;
                if ($(`[data-region-id="${regionId}"]`).length) {
                    $('[data-map-contacts]').show();

                    $('[data-map-contact-title]').show();
                    $('[data-map-contact-title] span').html(regionTitle);
                    $(`[data-region-id="${regionId}"]`).css("display", "flex").hide().fadeIn();
                    // setTimeout(() => {
                    // $([document.documentElement, document.body]).animate({
                    //     scrollTop: $('.contact-map__contacts').offset().top - topBarHeight,
                    // }, 300);
                    window.scrollToElement('.contact-map__contacts', 0, 500);
                    // }, 500);
                }

            });

            function zoom(map) {
                bounds = new google.maps.LatLngBounds();
                map.data.forEach(function (feature) {
                    processPoints(feature.getGeometry(), bounds.extend, bounds);
                });
                map.fitBounds(bounds);
                map.setZoom(6);
            }

            function processPoints(geometry, callback, thisArg) {
                if (geometry instanceof google.maps.LatLng) {
                    callback.call(thisArg, geometry);
                } else if (geometry instanceof google.maps.Data.Point) {
                    callback.call(thisArg, geometry.get());
                } else {
                    geometry.getArray().forEach(function (g) {
                        processPoints(g, callback, thisArg);
                    });
                }
            }

            function hideContacts() {
                $('[data-map-contacts]').hide();
                $('[data-region-id]').each(function () {
                    $(this).hide();
                });
            }

            searchLocation();
        }
    }

    function changeMarkerPos(lat, lon) {
        const myLatLng = new google.maps.LatLng(lat, lon);
        const zoom = map.getZoom();

        map.panTo(myLatLng);
        map.setZoom(9);

        setMarker(lat, lon);
    }

    function getLocation() {
        const btn = document.querySelector('[data-locate-btn]');
        const box = document.querySelector('.contact-map__search');
        const mapCanvas = document.getElementById('map-canvas');

        if(btn) {
            btn.addEventListener('click', () => {
                box.classList.add('contact-map__search--loading');
                const contacts = document.querySelector('[data-map-contacts]');
                contacts.style.display = 'none';
                hideMapInstitute();
                locateMe();
                mapCanvas.style.display = 'block';
            });
        }


        function locateMe() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(positionCallback, errorLocation);
            }
        }

        function errorLocation() {
            alert('Twoja lokalizacja dla tej strony jest wyłączona');
            box.classList.remove('contact-map__search--loading');
        }

        function positionCallback(position) {
            const geocoder = new google.maps.Geocoder();
            const latlng = new google.maps.LatLng(
                position.coords.latitude,
                position.coords.longitude,
            );

            geocoder.geocode({ latLng: latlng }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[1]) {
                        // find only the city name
                        for (let i = 0; i < results[0].address_components.length; i++) {
                            if (results[0].address_components[i].types[0] == 'locality') {
                                const lat = results[0].geometry.location.lat();
                                const lng = results[0].geometry.location.lng();
                                const city = results[0].address_components[i].long_name;
                                const input = document.getElementById('map-input-search');
                                const searchInfo = document.querySelector('[data-locate-info]');

                                input.value = city;
                                box.classList.remove('contact-map__search--loading');
                                changeMarkerPos(lat, lng);
                                searchInfo.style.display = 'block';
                            }
                        }
                    }
                }
            });
        }
    }

    getLocation();

    function searchLocation() {
        const input = document.getElementById('map-input-search');
        const autocomplete = new google.maps.places.Autocomplete(input);
        const mapCanvas = document.getElementById('map-canvas');
        const searchInfo = document.querySelector('[data-locate-info]');

        autocomplete.bindTo('bounds', map);
        const infowindow = new google.maps.InfoWindow();

        autocomplete.addListener('place_changed', function () {
            mapCanvas.style.display = 'block';
            hideMapInstitute();
            const contacts = document.querySelector('[data-map-contacts]');
            contacts.style.display = 'none';
            infowindow.close();
            const place = autocomplete.getPlace();

            if (!place.geometry) {
                return;
            }

            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            } else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);
            }

            setMarker(place.geometry.location.lat(), place.geometry.location.lng());
            searchInfo.style.display = 'block';
        });
    }

    function setMarker(lat, lng) {
        if (markers) {
            for (let i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
        }

        lat = parseFloat(lat);
        lng = parseFloat(lng);

        const marker = new google.maps.Marker({
            position: {
                lat: lat,
                lng: lng,
            },
            map,
        });

        markers.push(marker)
    }

    function showInstituteMarker() {
        const buttons = document.querySelectorAll('[data-institute-btn]');

        if (buttons.length) {
            buttons.forEach(button => {
                button.addEventListener('click', (e) => {
                    const lat = button.dataset.instituteLat;
                    const lng = button.dataset.instituteLng;
                    const title = button.dataset.instituteBtn;
                    const mapLink = button.dataset.instituteLink;

                    setMarker(lat, lng);
                    changeMarkerPos(lat, lng);
                    // map.setZoom(10);
                    initInstituteMap(lat, lng, title, mapLink);

                    const map = document.getElementById('map-canvas');
                    const contacts = document.querySelector('[data-map-contacts]');
                    if (map) {
                        map.style.display = 'none';
                    }
                    if (contacts) {
                        contacts.style.display = 'none';
                    }

                    window.scrollToElement('#map-institute');
                });
            });
        }
    }

    function initInstituteMap(lat, lng, title = null, mapLink = null) {
        // Basic options for a simple Google Map
        // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
        var mapOptions = {
            zoom: 15,
            scrollwheel: false,
            center: new google.maps.LatLng(50.0467656, 20.0048731),
            styles: [
                { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] },
                { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] },
                { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] },
                { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
                { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
                { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#e2231a" }, { "visibility": "on" }] },
            ],
        };
        // Get the HTML DOM element that will contain your map
        // We are using a div with id="map" seen below in the <body>

        var mapElement = document.getElementById('map-institute');
        mapElement.style.display = 'block';

        var map1 = new google.maps.Map(mapElement, mapOptions);

        var markerIcon = '<?php echo get_template_directory_uri() ?>' + '/dist/img/marker.png';

        function positionMap() {
            if (window.matchMedia('(max-width: 768px)').matches) {
                map1.setCenter(new google.maps.LatLng(lat, lng));
            } else if (window.matchMedia('(max-width: 1279px)').matches) {
                map1.setCenter(new google.maps.LatLng(lat, lng));
            } else {
                map1.setCenter(new google.maps.LatLng(lat, lng));
            }
        }

        positionMap();
        window.addEventListener('resize', positionMap);

        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            map: map1,
            // icon: markerIcon,
        });

        if (title || mapLink) {
            const googleMapLink = mapLink ? `<a href="${mapLink}" target="_blank" class="button button--black"><?= _e('Prowadź do', 'bp2') ?></a>` : '';
            const infowindow = new google.maps.InfoWindow({
                content: `<div class="contact-map__infowindow">
                    <span>${title}</span>
                    ${googleMapLink}
                </div>`,
            });
            google.maps.event.addListener(marker, 'click', () => {
                infowindow.open(map, marker);
            });
            infowindow.open(map, marker);
        }
    }

    function hideMapInstitute() {
        const mapInstitute = document.getElementById('map-institute');
        mapInstitute.style.display = 'none';
    }


    window.addEventListener('load', () => {
        showInstituteMarker();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/map.js
// module id = 20
// module chunks = 0